import { SocialNetworkBlock } from '@app/Layout/Footer/SocialNetworkBlock';
import { PhoneBlock } from './PhoneBlock';
import { PartnersBlock } from './PartnersBlock';

export const FooterRight = (): JSX.Element => {
  return (
    <div>
      <PhoneBlock />
      <SocialNetworkBlock />
      <PartnersBlock />
    </div>
  );
};
